export const ALL_WHITE_SPACE_REG_EXP = /.*[^ ].*/;
export const LATIN_AND_NUMBERS_REG_EXP = /[^(a-zA-Z0-9)]/gm;
export const NUMBERS_ONLY_REG_EXP = /[^0-9]/gm;
export const PHONE_REG_EXP = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
export const CAPITAL_LATIN_ONLY = /^[A-Z]+$/;
export const CAPITAL_LATIN_AND_NUMBERS_ONLY = /^$|^[A-Z0-9-_]+$/;
export const EMAIL_LIST_WITH_COMMA = /^(([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+([,.](([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+)*$/;
export const NUMBERS_ONLY = /^\d+$/;
export const NUMBERS_ONLY_WITH_EMPTY = /^$|^\d+$/;
export const NUM_RANGE_FROM_1_TO_999999 = /([1-9]|[1-9][0-9]|[1-9][0-9][0-9]|[1-9][0-9][0-9][0-9]|[1-9][0-9][0-9][0-9][0-9]|[1-9][0-9][0-9][0-9][0-9][0-9])/;
export const DATE_REG_EXP = /\d\d\d\d-\d\d\s\|\s/g;
export const CAMPAIGN_NAME_SEPARATOR_REG_EXP = /\|/g;